import React from "react";
import { MenuItem, Select } from "@mui/material";

function SelectType(props) {
  return (
    <Select
      onChange={(e) => {
        let value = "";
        if (e.target.value === "OR") {
          value = [];
        }
        sessionStorage.setItem("defaultConditionType", e.target.value);
        sessionStorage.removeItem("defaultConditionValue");
        props.onChange(e.target.value, value);
      }}
      value={props.value}
    >
      <MenuItem value={"POS"}>POS</MenuItem>
      <MenuItem value={"SOLUTION"}>SOLUTION</MenuItem>
      <MenuItem value={"OR"}>OR</MenuItem>
    </Select>
  );
}

export default SelectType;
